<!--结果页-->
<template>
  <div class="result">
    <van-popup round v-model="resultPop">
      <div class="content">
        <img
          class="rightbg"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/questionlottery/rightbg.png"
          alt=""
        />
        <!-- noadr -->
         <div class="noAdr" v-if="!this.adrdetail.province">
          <p>快去填写地址领取属于你的奖品吧</p>
          <div class="result-btn" @click="onClickAdr">填写收货地址</div>
         </div>
         <!-- hasadr -->
         <div class="hasAdr" v-if="this.adrdetail.province">
          <p>您已填写地址，坐等收货吧</p>
          <div class="result-btn" @click="onClickOk">好的</div>
         </div>

      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      resultPop: false,
    };
  },
  props: {
    adrdetail: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  watch: {

  },

  created() {
  },
  mounted() {

  },
  methods: {
    onClickAdr(){
      this.$router.push({
        path: '/tempadress',
        query: {},
      });
    },
    onClickOk(){
      this.resultPop = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.result {
  .content {
    position: relative;
    .rightbg {
      display: block;
      width: 600px;
      height: 758px;
      margin: 0 auto;
    }
    .noAdr,.hasAdr{
      position: absolute;
      left: 0;
      right:0;
      bottom:60px;
      p{
        font-weight: 400;
font-size: 28px;
color: #333333;
text-align: center;
      }
      .result-btn {
      width: 260px;
      height: 80px;
      background: linear-gradient(180deg, #ff6e75 0%, #ff216e 100%);
      border-radius: 40px;
      font-weight: 500;
      font-size: 32px;
      color: #ffffff;
      line-height: 80px;
      text-align: center;
      margin: 90px auto 0;
    }
    }

  }

  ::v-deep{
    .van-popup--center{
      top:47%;
    }
    .van-popup {
    background-color: transparent !important;
  }
  }
}
</style>
